module.exports = __webpack_public_path__ + "static/media/chocologo1.73a85e4b.png";